// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { GenericGet } from '../../../../types/server/modules/generic/get';

export type * from '../../../../types/server/modules/generic/get';

export const createGet = ( requests: Requests ): GenericGet => ({
  realtime_session: ( headers ) => {
      return requests.get( `/realtime-session`, undefined, headers );
    }
});
